namespace GeniuzPOS.Purchase {
    export interface PoApprovalRow {
        Id?: number;
        Level?: LevelApp;
        DocType?: string;
        DocName?: string;
        Mininum?: number;
        ApprGroupCode?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PoApprovalRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocType';
        export const localTextPrefix = 'Purchase.PoApproval';
        export const lookupKey = 'Purchase.PoApproval';

        export function getLookup(): Q.Lookup<PoApprovalRow> {
            return Q.getLookup<PoApprovalRow>('Purchase.PoApproval');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Level = "Level",
            DocType = "DocType",
            DocName = "DocName",
            Mininum = "Mininum",
            ApprGroupCode = "ApprGroupCode",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
